import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Viverano Organics' "Milan Baby Button
// Cardigan Sweater Knit (Organic Cotton)" (p_hu4vcpjcbz), read from GET
// /api/product-reviews/product/p_hu4vcpjcbz — verbatim comment, real
// reviewer, real rating, real publish date.
export const review_vo2: FaireReviewEntity = {
  token: "review_vo2",
  type: "review",
  brandName: "Viverano Organics",
  brandToken: "b_7fghelgl",
  productToken: "p_hu4vcpjcbz",
  reviewType: "product",
  reviewerName: "Shea H.",
  reviewerLocation: "Daniel Island, SC",
  stars: 5,
  reviewText: "These are precious clothes and designs. They are super soft!",
  reviewDate: "Nov 18, 2022",
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
